import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track on production domain
    const isProduction = window.location.hostname === 'www.joinblockclub.com';

    // Check if gtag is available and we're on production
    if (isProduction && typeof window.gtag !== 'undefined') {
      // Send page view to Google Analytics
      window.gtag('config', 'G-SGGFG37WTH', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
};

export default usePageTracking;
